var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccionaMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5838,
    cy: 23.5838,
    r: 23.5838,
    fill: "#F5B6B6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8729_399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4776 18.9157C27.4776 21.0301 25.734 22.7108 23.609 22.7108C21.484 22.7108 19.7404 21.0301 19.7404 18.9157C19.7404 16.8012 21.484 15.1205 23.609 15.1205C25.734 15.1205 27.4776 16.8012 27.4776 18.9157ZM28.8942 18.9157C28.8942 16.0422 26.4968 13.7108 23.609 13.7108C20.7212 13.7108 18.3237 16.0422 18.3237 18.9157C18.3237 21.7892 20.7212 24.1205 23.609 24.1205C26.4968 24.1205 28.8942 21.7892 28.8942 18.9157ZM30.5833 19.3494C30.5833 20.5422 30.2564 21.7349 29.6571 22.7651L23.5545 34.9096L17.234 22.6566C16.6891 21.6265 16.3622 20.488 16.3622 19.3494C16.3622 15.5 19.5769 12.4096 23.4455 12.4096C27.3141 12.4096 30.5833 15.5 30.5833 19.3494ZM32 19.3494C32 14.741 28.1859 11 23.5 11C18.8141 11 15 14.741 15 19.3494C15 20.759 15.3814 22.1145 16.0353 23.3072L22.8462 36.5904H18.5962V38H28.6763V36.5904H24.2628L30.9103 23.4157C31.6186 22.2229 32 20.759 32 19.3494Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8729_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 27,
    fill: "white",
    transform: "translate(15 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccionaMarker);
export default __webpack_public_path__ + "static/media/acciona_marker.9e9110c376a0483b21f86b0ba88f853c.svg";
export { ForwardRef as ReactComponent };